import React from 'react'
import Tooltip, { Place } from 'react-tooltip'
import { I18n } from 'react-redux-i18n'
import uuid from 'uuid/v4'

export interface Props {
  content: string
  place?: Place
}

const HelpTooltip = (props: Props) => {
  const { content, place } = props
  const tipId = uuid()
  return (
    <span className="d-flex flex-row align-items-center">
      <span className="tooltip-image" data-tip={I18n.t(content)} data-for={tipId}>
        ?
      </span>
      <Tooltip
        className="tooltip"
        id={tipId}
        effect="solid"
        type="light"
        place={place || 'bottom'}
        delayShow={300}
        multiline={true}
      />
    </span>
  )
}

export default HelpTooltip
